import { render, staticRenderFns } from "./Roadmap_components.vue?vue&type=template&id=65f95805&scoped=true&"
import script from "./Roadmap_components.vue?vue&type=script&lang=js&"
export * from "./Roadmap_components.vue?vue&type=script&lang=js&"
import style0 from "./Roadmap_components.vue?vue&type=style&index=0&id=65f95805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f95805",
  null
  
)

export default component.exports